import { siteInfo } from '@/mocks/comics';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>;
}

export default function SEOHead({
  title = `${siteInfo.name} - ${siteInfo.slogan}`,
  description = siteInfo.description,
  keywords = '漫画,免费阅读,国产漫画,热血漫画,恋爱漫画,玄幻漫画,吹雪漫画网',
  canonicalUrl = '/',
  ogType = 'website',
  schemaData,
}: SEOHeadProps) {
  return (
    <>
      {schemaData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      )}
    </>
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://chuixue.manhua.com',
    description: siteInfo.description,
    foundingDate: siteInfo.founded,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.email,
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    sameAs: [],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://chuixue.manhua.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://chuixue.manhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://chuixue.manhua.com',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(
  title: string,
  description: string,
  url: string,
  author: string,
  datePublished: string,
  imageUrl: string,
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url,
    author: {
      '@type': 'Person',
      name: author,
    },
    datePublished,
    dateModified: datePublished,
    image: imageUrl,
    publisher: {
      '@type': 'Organization',
      name: siteInfo.name,
    },
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}